export const SANITIZE_FILENAME_REGEX = new RegExp(/[^\p{L}\p{N}_.-]/gu);
